// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1-_Dv","footer":"ModalError_footer__3AA5p"};